import React, { useState } from 'react';
import axios from 'axios';
import './SignupIslam.css';
import { useNavigate } from 'react-router-dom';
import Bubbles from '../Bubbles'
import ImportantInstructionsCard from '../components/ImportantInstructionsCard';

const Signup = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [educationalLevel, setEducationalLevel] = useState('');
  const [response, setResponse] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [showInstructions, setShowInstructions] = useState(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== passwordConfirmation) {
      setError('Passwords do not match');
      return;
    }

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/signup`, {
        name: `${firstName} ${lastName}`,
        phone,
        password,
        educational_level: educationalLevel,
      });

      setResponse(res.data);
      console.log('Registration Success:', res.data);
      navigate('/LoginIslam');

    } catch (error) {
      setError('Registration Failed: ' + (error.response ? error.response.data : error.message));
      console.error('Registration Failed:', error.response ? error.response.data : error.message);
    }
  };
  const goHome =async (e) => {
    navigate('/Mr.IslamAbdElazeem')
  }
  return (
    <div className="signup-page12s relative min-h-screen flex justify-center items-center bg-gray-100">
      
      {/* Important Instructions Card Overlay */}
      {showInstructions && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start pt-8 z-50">
          <ImportantInstructionsCard onClose={() => setShowInstructions(false)} />
        </div>
      )}

      {/* Signup Card */}
      <div className="signup-card animiL bg-white p-6 md:p-10 rounded-2xl shadow-xl max-w-3xl w-full z-10">
        <h2 className="signup-title text-3xl font-bold text-center mb-4">Create Account</h2>
        <p className="signup-subtitle text-center mb-6">
          Already a member? <a href="/Login" className="text-blue-600 underline">Log In</a>
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="form-row flex gap-4 flex-col md:flex-row">
            <div className="form-group flex-1">
              <label>First Name</label>
              <input
                type="text"
                placeholder="Mohamed"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
                className="w-full border border-gray-300 rounded px-3 py-2"
              />
            </div>
            <div className="form-group flex-1">
              <label>Last Name</label>
              <input
                type="text"
                placeholder="Hussien"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
                className="w-full border border-gray-300 rounded px-3 py-2"
              />
            </div>
          </div>

          <div className="form-row flex gap-4 flex-col md:flex-row">
            <div className="form-group flex-1">
              <label>Mobile Number</label>
              <input
                type="text"
                placeholder="010000000"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
                className="w-full border border-gray-300 rounded px-3 py-2"
              />
            </div>
            <div className="form-group flex-1">
              <label>Password</label>
              <input
                type="password"
                placeholder="Enter password here"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full border border-gray-300 rounded px-3 py-2"
              />
            </div>
          </div>

          <div className="form-row flex gap-4 flex-col md:flex-row">
            <div className="form-group flex-1">
              <label>Confirm Password</label>
              <input
                type="password"
                placeholder="Confirm Password"
                value={passwordConfirmation}
                onChange={(e) => setPasswordConfirmation(e.target.value)}
                required
                className="w-full border border-gray-300 rounded px-3 py-2"
              />
            </div>
            <div className="form-group flex-1">
              <label>Educational Level</label>
              <select
                value={educationalLevel}
                onChange={(e) => setEducationalLevel(e.target.value)}
                required
                className="w-full border border-gray-300 rounded px-3 py-2"
              >
                <option value="">Select Educational Level</option>
                <option value="الصف الاول الثانوي">الصف الاول الثانوي</option>
                <option value="الصف الثاني الثانوي">الصف الثاني الثانوي</option>
                <option value="الصف الثالث الثانوي">الصف الثالث الثانوي</option>
                <option value="الصف الثالث الاعدادي">الصف الثالث الاعدادي</option>
              </select>
            </div>
          </div>

          <div className="form-group checkbox-group flex items-center">
            <input type="checkbox" id="terms" required className="mr-2"/>
            <label htmlFor="terms">
              By signing up, you agree to our <span className="terms-link text-blue-600 underline">Terms of Service</span>
            </label>
          </div>

          <div className="flex gap-4 mt-4">
            <button type="submit" className="btn-signup bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition">Sign Up</button>
            <button type="button" onClick={goHome} className="btn-home bg-gray-300 px-6 py-2 rounded hover:bg-gray-400 transition">الرئيسيه</button>
          </div>
        </form>

        {response && <div className="response success mt-4 text-green-600">{response.message || 'Registration Successful 🎉'}</div>}
        {error && <div className="response error mt-4 text-red-600">{error}</div>}
      </div>
    </div>
  );
};

export default Signup;
